import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import Header from '../header/Header';
import Sidebarr from '../sidebar/Sidebar';
import VendorSidebar from '../sidebar/VendorSidebar';
import Tool from '../sidebar/Tool';
import Footer from '../footer/Footer';
import axios from "../helper/axios";
import { signedProductTotal } from "../helper/orderTotals";
import Invoice from './Invoice';
import "./style.css";
import { useSelector } from "react-redux";
import moment from "moment-js"

export default function ProductList() {
  const [allProduct, setAllProduct] = useState([]);
  const [statusValue, setStatusValue] = useState([]);
  const [modalBox, setModalBox] = useState(false);
  const [ChangeDeliveryCharge, setChangeDeliveryCharge] = useState(0);
  const [notex, setNotes] = useState("");
  const [orderIdx, setOrderId] = useState();
  const [deliverRates, setDeliverRates] = useState();
  const [allNotes, setAllNotes] = useState([]);
  const [vatData, setVatData] = useState();

  const [updateQty, setUpdateQty] = useState({});
  const [widthoutVatData, setWidthoutVatData] = useState(0);
  const [constVatData, setConstVatData] = useState(0);
  const [productItemId, setProductItemId] = useState("");
  const [productSize, setProductSize] = useState("");
  const [reasonForRefund, setReasonForRefund] = useState("");
  const [qtyValue, setQtyValue] = useState({});
  const [itemData, setItemData] = useState([]);
  const [itemSize, setItemSize] = useState([]);
  const [itemQTY, setItemQTY] = useState([]);
  const [sale_price_data, setSale_price] = useState("");
  const [regular_price_data, setRegular_price] = useState("");
  const [totalRefund, setTotalRefund] = useState(0);
  const [x, setx] = useState(0);
  const [statusColor, setStatusColor] = useState([]);
  const [disableModal, setDisableModal] = useState({ show: false, orderId: "", index: null, reason: "" });
  const [transportModal, setTransportModal] = useState({ show: false, orderId: "", index: 0 });
  const [exchangeModal, setExchangeModal] = useState({
    show: false,
    selectedIndexes: [],
    search: "",
    searching: false,
    results: [],
    incoming: [],
    submitting: false,
    error: "",
  });
  const [invoiceRefreshToken, setInvoiceRefreshToken] = useState(0);
  const itemCodeData = [];

  const isProductActiveForInvoice = (product) => {
    if (product?.includeItem === false) return false;
    if (product?.status === false) return false;
    return true;
  };

  const refreshInvoicePreview = () => {
    setInvoiceRefreshToken((prev) => prev + 1);
  };

  const auth = useSelector(state => state.auth);
  let { id } = useParams();

  const apiData = async () => {
    const data = { id: id }
    const res = await axios.post("/getorderslist", data);

    if (res.status === 200) {
      setAllProduct(res?.data);
      setChangeDeliveryCharge(res?.data[0].deliverMode);

      res?.data?.map(dtx => {
        setOrderId(dtx?.orderId);
        setDeliverRates(dtx?.deliverMode);
      })
    } else {
      setAllProduct()
    }
  }

  const vatGetData = async () => {
    const res = await axios.post("/getvatupdate");
    console.log(res?.status);
    console.log(res.data)
    if (res.status === 200) {
      setVatData(res?.data[0]?.vatData);
    } else {
      setVatData()
    }
  }


  const getNotes = async () => {
    const data = { orderId: orderIdx }
    const res = await axios.post("/getnotes", data)

    setAllNotes(res.data);
  }

  useEffect(() => {
    apiData();

    getNotes();
    vatGetData();
  }, [])

  var sum = 0;
  var vataDataPrice = 0;
  allProduct?.forEach(dt => {

    // for (let key in dt?.productList) {

    //   // sum += dt?.productList[key].sale_price*dt?.productList[key].quantity;
    //   sum += (dt?.productList[key]?.sale_price > 0 ? dt?.productList[key].sale_price : dt?.productList[key].regular_price) * dt?.productList[key].quantity;
    //   vataDataPrice = (sum * vatData / 100);
    //   //sum = sum + vataDataPrice;
    //   sum = sum;
    // }


    for (let key in dt?.productList) {
      const item = dt?.productList[key];
      if (isProductActiveForInvoice(item)) {
        sum = sum + signedProductTotal(item);
      }
    };


  })




  var totalPriceData = sum + parseFloat(vatData) + parseFloat(deliverRates);

  const updateOrder = async () => {
    const data = { id: id, orderId: orderIdx, statusValue: notex }
    const res = await axios.post("/updateorder", data);
    await sendNotes();
    if (res.status === 200) {
      apiData();
      alert("Order Updated");
    }

  }

  const sendNotes = async () => {
    const data = { orderId: orderIdx, notes: notex }
    console.log(orderIdx)
    const res = await axios.post("/sendnotes", data)
    await getNotes();
    if (res.status === 200) {
      apiData();
      alert("Note status updated");
    }
  }


  const updateValue = e => {
    this.functionOne(e)
    this.functionTwo()
  }



  const apiStatusColorData = async () => {
    const res = await axios.post("/getstatus");
    if (res.status === 200) {
      setStatusColor(res?.data);
    } else {
      setStatusColor()
    }
  }

  useEffect(() => {
    apiStatusColorData();
  }, [])


  const textFile = () => {
    // const datax=[{name:"Dpk"},{name:"rhl"},{name:"styjeet"}]
    var myString = "";

    for (let key in allProduct[0]?.productList) {
      const item = allProduct[0].productList[key];
      if (!isProductActiveForInvoice(item)) continue;

      myString += "S,1,______,_,__;" + item.name + ";" + (item.sale_price > 0 ? item.sale_price : item.regular_price) + ";" + item.quantity + ";1;1;5;0;" + item.item_code + ";0;0;\n"
    }
    if (allProduct[0]?.deliverMode > 0) {
      myString += "S,1,______,_,__;Transporti;" + allProduct[0]?.deliverMode + ";1;1;1;5;0;A12341234;0;\n"
    }
    myString += "C,1,________,_,__;1;0;\n"
    myString += "Q,1,______,_,__;1; ___________\n";
    myString += "Q,1,______,_,__;2; Ref Nr:\n";
    myString += "T,1,______,_,__;3\n";


    const element = document.createElement("a");
    const file = new Blob([myString], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = allProduct[0].orderId + ".inp";
    document.body.appendChild(element);
    element.click();
  }





  const deteleProduct = async (orderId, index) => {
    const data = { id: orderId, index };
    if (window.confirm('Are you sure you want to delete this item')) {
      const res = await axios.post("/deleteOrderById", data);
      if (res.status === 200) {
        apiData();
        refreshInvoicePreview();
        alert('Product Deleted');
      }
    }
  }


  const deleteDeliveryMode = async (orderId) => {
    const data = { deliverymode: ChangeDeliveryCharge, orderId: orderId }
    if (window.confirm('Are you sure you want to delete Delivery Charges')) {
      const res = await axios.post("/deletedeliverymode", data)
      if (res.status === 200) {
        apiData();
        refreshInvoicePreview();
        alert('Delivery Price Deleted ⛔');
      }
    }
  }

  const editDeliveryMode = async (orderId) => {
    const data = { deliverymode: ChangeDeliveryCharge, orderId: orderId }
    const res = await axios.post("/editDeliveryMode", data)
    if (res.status === 200) {
      apiData();
      refreshInvoicePreview();
      alert('Delivery Price Updated 👍');
    }

  }

  const openTransportModal = (orderId, index = 0) => {
    setTransportModal({ show: true, orderId, index });
  }

  const closeTransportModal = () => {
    setTransportModal({ show: false, orderId: "", index: 0 });
  }

  const addProductTransport = async (transportPrice) => {
    const { orderId, index } = transportModal;
    if (!window.confirm(`A jeni të sigurt që dëshironi të shtoni transport ${transportPrice}€ për këtë produkt?`)) {
      return;
    }

    try {
      const data = { orderId, index, transportPrice };
      const res = await axios.post("/addProductTransport", data);
      if (res.status === 200) {
        closeTransportModal();
        apiData();
        refreshInvoicePreview();
        alert('Transporti u shtua me sukses');
      }
    } catch (error) {
      alert('Gabim: ' + (error.response?.data?.error || error.message));
    }
  }

  const openDisableModal = (orderId, index) => {
    setDisableModal({ show: true, orderId, index, reason: "" });
  }

  const closeDisableModal = () => {
    setDisableModal({ show: false, orderId: "", index: null, reason: "" });
  }

  const submitDisableProduct = async () => {
    const { orderId, index, reason } = disableModal;
    if (!String(reason || "").trim()) {
      alert("Ju lutem shkruani arsyen");
      return;
    }

    try {
      const data = { orderId, index, reason: reason.trim() };
      const res = await axios.post("/toggleProductStatus", data);
      if (res.status === 200) {
        closeDisableModal();
        apiData();
        refreshInvoicePreview();
        alert("Produkti u përjashtua nga invoice");
      }
    } catch (error) {
      alert('Gabim: ' + (error.response?.data?.error || error.message));
    }
  }

  useEffect(() => {
    allProduct[0]?.productList?.map((pdx, index) => {

      if (updateQty > 0) {
        setWidthoutVatData((pdx?.sale_price > 0 ? (parseFloat(pdx?.sale_price).toFixed(2) - (parseFloat(pdx?.sale_price).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)).toFixed(2) : (parseFloat(pdx?.regular_price).toFixed(2) - (parseFloat(pdx?.regular_price).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)).toFixed(2)) / updateQty)

        setProductItemId(pdx.item_code)
        setProductSize(pdx.size)

        setConstVatData((pdx?.sale_price > 0 ? (parseFloat(pdx?.sale_price).toFixed(2) * parseFloat(pdx?.quantity).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2) : (parseFloat(pdx?.regular_price).toFixed(2) * parseFloat(pdx?.quantity).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)) / updateQty)
      } else {
        setWidthoutVatData(0)
      }

    })
  }, [updateQty])



  const refundNow = async () => {
    const data = {
      refundPrice: totalRefund,
      itemCode: itemData,
      qty: itemQTY,
      orderId: id,
      size: itemSize,
      reasonForRefund: reasonForRefund,
      sale_price_data: sale_price_data,
      regular_price_data: regular_price_data
    }
    const res = await axios.post("/refunddata", data);

    await alert("Refund processed successfully.");
  }

  const handleRefundChange = (event, itemCode, itemSize, totalAmt, sale_price, regular_price) => {
    var totalAmtVar = event.target.value > 0 ? (totalRefund + totalAmt) / event.target.value : "";
    console.log(totalAmtVar)
    setTotalRefund(totalAmtVar)
    const name = event.target.name;
    const value = event.target.value;
    setQtyValue(values => ({ ...values, [name]: value }))
    setItemData(values => ([...values, itemCode]))
    setItemSize(values => ([...values, itemSize]))
    setItemQTY(values => ([...values, value]))
    setSale_price(sale_price)
    setRegular_price(regular_price)
  }

  const handleReturnOrder = async () => {
    if (window.confirm('A jeni të sigurt që dëshironi të ktheni këtë porosi? Do të krijohet një dokument i ri me vlera negative.')) {
      try {
        const data = { orderId: allProduct[0]?.orderId };
        const res = await axios.post("/returnorder", data);
        if (res.status === 200) {
          alert(`Porosia u kthye me sukses! ID e re: ${res.data.returnOrderId}`);
          apiData();
        }
      } catch (error) {
        alert('Gabim gjatë kthimit të porosisë: ' + (error.response?.data?.error || error.message));
      }
    }
  }

  const handleCancelOrder = async () => {
    if (window.confirm('A jeni të sigurt që dëshironi të anuloni këtë porosi? Do të krijohet një dokument i ri me vlera negative.')) {
      try {
        const data = { orderId: allProduct[0]?.orderId };
        const res = await axios.post("/cancelorder", data);
        if (res.status === 200) {
          alert(`Porosia u anulua me sukses! ID e re: ${res.data.cancelOrderId}`);
          apiData();
        }
      } catch (error) {
        alert('Gabim gjatë anulimit të porosisë: ' + (error.response?.data?.error || error.message));
      }
    }
  }

  const openExchangeModal = () => {
    setExchangeModal({
      show: true,
      selectedIndexes: [],
      search: "",
      searching: false,
      results: [],
      incoming: [],
      submitting: false,
      error: "",
    });
  }

  const closeExchangeModal = () => {
    if (exchangeModal.submitting) return;
    setExchangeModal((prev) => ({ ...prev, show: false }));
  }

  const locationsForIndexes = (indexes) => {
    const list = allProduct[0]?.productList || [];
    return [...new Set((indexes || []).map((index) => String(list[index]?.location || "").trim()))];
  }

  const toggleExchangeIndex = (index) => {
    setExchangeModal((prev) => {
      const exists = prev.selectedIndexes.includes(index);
      const selectedIndexes = exists
        ? prev.selectedIndexes.filter((value) => value !== index)
        : [...prev.selectedIndexes, index];
      const nextLocations = locationsForIndexes(selectedIndexes);
      const previousLocations = locationsForIndexes(prev.selectedIndexes);
      const locationChanged = nextLocations.join("|") !== previousLocations.join("|");
      const locationError = nextLocations.length > 1
        ? "Produktet e zgjedhura duhet të jenë nga i njëjti location"
        : "";

      return {
        ...prev,
        selectedIndexes,
        results: locationChanged ? [] : prev.results,
        incoming: locationChanged ? [] : prev.incoming,
        error: locationError,
      };
    });
  }

  const searchExchangeProducts = async () => {
    const search = String(exchangeModal.search || "").trim();
    const locations = locationsForIndexes(exchangeModal.selectedIndexes);
    if (!exchangeModal.selectedIndexes.length) {
      setExchangeModal((prev) => ({ ...prev, error: "Zgjidhni së pari produktin që do të ndërrohet" }));
      return;
    }
    if (locations.length !== 1 || !locations[0]) {
      setExchangeModal((prev) => ({
        ...prev,
        error: locations.length > 1
          ? "Produktet e zgjedhura duhet të jenë nga i njëjti location"
          : "Produkti i zgjedhur nuk ka location",
      }));
      return;
    }
    if (!search) {
      setExchangeModal((prev) => ({ ...prev, error: "Shkruani SKU ose External ID" }));
      return;
    }

    const location = locations[0];
    setExchangeModal((prev) => ({ ...prev, searching: true, error: "", results: [] }));
    try {
      const res = await axios.post("/searchexchangeproduct", { search, location });
      const results = (res.data?.results || []).filter(
        (item) => String(item?.location || "").trim() === location
      );
      setExchangeModal((prev) => ({
        ...prev,
        searching: false,
        results,
        error: results.length ? "" : `Nuk u gjet asnjë produkt në location ${location}`,
      }));
    } catch (error) {
      setExchangeModal((prev) => ({
        ...prev,
        searching: false,
        error: error.response?.data?.error || error.message,
      }));
    }
  }

  const addIncomingProduct = (product) => {
    const locations = locationsForIndexes(exchangeModal.selectedIndexes);
    const location = locations.length === 1 ? locations[0] : "";
    if (!location || String(product?.location || "").trim() !== location) {
      setExchangeModal((prev) => ({
        ...prev,
        error: location
          ? `Zëvendësuesi duhet të jetë nga location ${location}`
          : "Zgjidhni së pari produktin që do të ndërrohet",
      }));
      return;
    }

    setExchangeModal((prev) => {
      const exists = prev.incoming.some(
        (item) => item.skuId === product.skuId && item.externalId === product.externalId
      );
      if (exists) return prev;

      const outgoingCount = prev.selectedIndexes.length;
      const defaultQty = outgoingCount === 1 && prev.incoming.length === 0
        ? Math.abs(Number(allProduct[0]?.productList?.[prev.selectedIndexes[0]]?.quantity) || 1)
        : 1;

      return {
        ...prev,
        incoming: [...prev.incoming, { ...product, quantity: defaultQty }],
        error: "",
      };
    });
  }

  const updateIncomingQty = (skuId, externalId, quantity) => {
    const qty = Math.max(1, Math.min(99, Math.floor(Number(quantity) || 1)));
    setExchangeModal((prev) => ({
      ...prev,
      incoming: prev.incoming.map((item) =>
        item.skuId === skuId && item.externalId === externalId
          ? { ...item, quantity: qty }
          : item
      ),
    }));
  }

  const removeIncomingProduct = (skuId, externalId) => {
    setExchangeModal((prev) => ({
      ...prev,
      incoming: prev.incoming.filter(
        (item) => !(item.skuId === skuId && item.externalId === externalId)
      ),
    }));
  }

  const submitExchangeOrder = async () => {
    const locations = locationsForIndexes(exchangeModal.selectedIndexes);
    if (!exchangeModal.selectedIndexes.length || !exchangeModal.incoming.length) {
      setExchangeModal((prev) => ({
        ...prev,
        error: "Zgjidhni produktet që dalin dhe të paktën një produkt zëvendësues",
      }));
      return;
    }
    if (locations.length !== 1 || !locations[0]) {
      setExchangeModal((prev) => ({
        ...prev,
        error: locations.length > 1
          ? "Produktet e zgjedhura duhet të jenë nga i njëjti location"
          : "Produkti i zgjedhur nuk ka location",
      }));
      return;
    }
    const location = locations[0];
    if (exchangeModal.incoming.some((item) => String(item.location || "").trim() !== location)) {
      setExchangeModal((prev) => ({
        ...prev,
        error: `Zëvendësuesi duhet të jetë nga location ${location}`,
      }));
      return;
    }

    setExchangeModal((prev) => ({ ...prev, submitting: true, error: "" }));
    try {
      const res = await axios.post("/exchangeorder", {
        orderId: allProduct[0]?.orderId,
        outgoingIndexes: exchangeModal.selectedIndexes,
        incoming: exchangeModal.incoming.map((item) => ({
          skuId: item.skuId,
          externalId: item.externalId,
          quantity: item.quantity,
        })),
      });
      if (res.status === 200) {
        alert(`Porosia e exchange u krijua! ID e re: ${res.data.exchangeOrderId}`);
        setExchangeModal((prev) => ({ ...prev, show: false, submitting: false }));
        apiData();
        refreshInvoicePreview();
      }
    } catch (error) {
      setExchangeModal((prev) => ({
        ...prev,
        submitting: false,
        error: error.response?.data?.error || error.message,
      }));
    }
  }

  // Use deliverMode directly from database (already calculated based on orderTotal)
  const shipping = allProduct[0]?.deliverMode || 0;

  const productList = allProduct[0]?.productList || [];
  const firstActiveProductIndex = productList.findIndex(isProductActiveForInvoice);
  const firstActiveProduct =
    firstActiveProductIndex >= 0 ? productList[firstActiveProductIndex] : null;
  const canAddTransport =
    firstActiveProductIndex >= 0 &&
    !(Number(firstActiveProduct?.shipping_price) > 0);

  const orderTotal =
    parseFloat(sum.toFixed(2)) + parseFloat(shipping.toFixed(2));

  const currentOrderId = allProduct[0]?.orderId || "";
  const canExchange = currentOrderId.startsWith("AO");
  const selectedExchangeLocations = [...new Set(
    exchangeModal.selectedIndexes.map((index) => String(allProduct[0]?.productList?.[index]?.location || "").trim())
  )];
  const exchangeLocation = selectedExchangeLocations.length === 1 ? selectedExchangeLocations[0] : "";
  const exchangeCandidates = (allProduct[0]?.productList || [])
    .map((product, index) => ({ product, index }))
    .filter(({ product }) => isProductActiveForInvoice(product));

  return (
    <>
      <div className="sidebar-mini skin-green-light admin-content">
        <div className="wrapper">
          <Header />
          {auth?.user?.role === "Vendor" ? <VendorSidebar /> : <Sidebarr />}
          <div className="content-wrapper">
            <section className="content-header">
              <h1>Order Details</h1>
            </section>
            <section className="content">
              <div className="row">
                <div className="col-sm-9">
                  <div className="box">

                    <div className="box-body order-detail">

                      {allProduct?.map(dt => (
                        <div>
                          <div className="od-heading">
                            <h4>Order #{dt?.orderId} Details { }</h4>
                            <h5>Payment via me {dt?.paymentMethod === "credit_card" ? "kartelë bankare" : "para në dorë"}{" "} <span style={{ fontWeight: "bold" }}>Customer IP</span>: 46.99.32.38</h5>
                          </div>
                          <div className="col-sm-4">
                            <h4>General</h4>
                            <div>
                              <h5>Date Created:</h5>
                              <input type="text" value={moment(dt.createdAt).format('YYYY-MM-dd')} readOnly={true} />
                            </div>
                            <div className='status-order'>
                              <h4>Status</h4>
                              {statusColor.map(mtchStatus => (
                                <div>
                                  {mtchStatus?.statusName === dt?.status ? <div className='label label-default' style={{ backgroundColor: `${mtchStatus.statusColor}`, color: `${mtchStatus.statusTextColor}`, textTransform: "capitalize" }}>{dt?.status}</div> : ""}
                                </div>
                              ))}

                            </div>

                            <div>
                              <div className="od-customer">
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 billingg">
                            <div className="od-billing">
                              <h4>Billing Address</h4>
                            </div>
                            <p>{dt?.fname} {dt?.lname}</p>
                            <p>{dt?.address}</p>
                            <p>{dt?.city}</p>
                            <p>Kosovë</p>
                            <div className="od-email">
                              <h5>Email Address:</h5>
                              <a href="/#">{dt?.email}</a>
                            </div>
                            <div className="od-phone">
                              <h5>Phone:</h5>
                              <a href="/#">
                                {[dt?.phonePrefix, dt?.phoneNumber]
                                  .filter(Boolean)
                                  .join(" ")}
                              </a>
                            </div>
                          </div>
                          <div className="col-sm-4 shippingg">
                            <div className="od-shipping">
                              <h4>Shipping Address</h4>
                            </div>
                            <p>{dt?.address}</p>
                            <p>{dt?.city}</p>
                            <p>Kosovë</p>
                          </div>

                          <div className="col-sm-4 shippingg">
                            <div className="od-shipping">
                              <h4>Shipping Note</h4>
                            </div>
                            <p>{dt?.anyComment?.length > 0 ? dt?.anyComment : "NA"}</p>
                          </div>
                          <div className="col-sm-4 shippingg">
                            <div className="od-shipping">
                              <h4>ShippingMethod</h4>
                            </div>
                            <p>
                              {dt?.shippingMethod
                                ? dt.shippingMethod === "boxes"
                                  ? "BOXES"
                                  : dt.shippingMethod === "standard"
                                    ? "STANDARD"
                                    : dt.shippingMethod
                                : "NA"}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="box">
                    <div className="box-body od-box-body">
                      <div className="od-table-scroll">
                      <table className="od-table">
                        <thead>
                          <tr className="od-tr">
                            <th className="item">Item <span><i className="fa fa-arrow-up"></i></span></th>
                            <th className="item-cost itemm" >Send</th>
                            <th className="item-cost itemm">Approved</th>
                            <th className="item-cost">Qty</th>
                            <th className="item-cost">Without<br />VAT</th>
                            <th className="item-cost itemm">With <br /> VAT</th>
                            <th className="item-cost">Total</th>
                            <th className="item-cost">Action</th>
                          </tr>
                        </thead>
                        <tbody>

                          {allProduct[0]?.productList?.map((pdx, index) => {

                            ///console.log("Pdx data === ", pdx?._id);

                            const isDisabled = !isProductActiveForInvoice(pdx);

                            return (
                              <tr
                                key={`${pdx?.item_code}-${index}`}
                                className={isDisabled ? "od-product-disabled" : ""}
                              >
                                <td className="thumb">
                                  <div className="">
                                    <img width="100" height="140" src={pdx?.images[0]} className="" loading="lazy" alt='' /></div>
                                  <div className="name">
                                    <a href={`https://albionline.com/productdetails/${pdx?._id}/${pdx?.catId}`} target="_blank" rel="noreferrer">{pdx?.name}</a>
                                    <div className="wc-order-item-sku"><strong>SKU:</strong> {pdx.item_code}</div>
                                    <div className="wc-order-item-sku"><strong>Sizes:</strong> {pdx.size}</div>

                                    <em className="wcpv-sold-by-order-details">Sold By: <a href="https://management.albionline.com/vendor/women-secret/" title={pdx.vendor}>{pdx.vendor}</a></em>
                                  </div>
                                </td>
                                <td>
                                  <i className="fa fa-solid fa-check"></i>
                                </td>
                                <td>
                                  <i className="fa fa-solid fa-check"></i>
                                </td>
                                <td>
                                  <div className="view">{pdx?.quantity} ×</div>
                                </td>
                                <td>
                                  {/* <div className="view">{pdx?.sale_price > 0 ? (parseFloat(pdx?.sale_price).toFixed(2) - (parseFloat(pdx?.sale_price).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)).toFixed(2) : (parseFloat(pdx?.regular_price).toFixed(2) - (parseFloat(pdx?.regular_price).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)).toFixed(2)} €
                                  </div> */}
                                  <div className="view">
                                    {(() => {
                                      const salePrice = parseFloat(pdx?.sale_price) || 0;
                                      const regularPrice = parseFloat(pdx?.regular_price) || 0;
                                      const vatPercentage = parseFloat(vatData) || 0;

                                      const calculatePrice = (price) =>
                                        (price - (price * vatPercentage) / 100).toFixed(2);

                                      return salePrice > 0
                                        ? calculatePrice(salePrice)
                                        : calculatePrice(regularPrice);
                                    })()} €
                                  </div>
                                </td>
                                <td>
                                  {/* <div className="view">{pdx?.sale_price > 0 ? (parseFloat(pdx?.sale_price).toFixed(2) * parseFloat(pdx?.quantity).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2) : (parseFloat(pdx?.regular_price).toFixed(2) * parseFloat(pdx?.quantity).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)} €</div> */}

                                  <div className="view">
                                    {(() => {
                                      const salePrice = parseFloat(pdx?.sale_price) || 0;
                                      const regularPrice = parseFloat(pdx?.regular_price) || 0;
                                      const quantity = parseFloat(pdx?.quantity) || 0;
                                      const vatPercentage = parseFloat(vatData) || 0;

                                      const calculatePrice = (price) =>
                                        ((price * quantity * vatPercentage) / 100).toFixed(2);

                                      return salePrice > 0
                                        ? calculatePrice(salePrice)
                                        : calculatePrice(regularPrice);
                                    })()} €
                                  </div>
                                </td>

                                <td>
                                  <div className="view">{signedProductTotal(pdx).toFixed(2)} €</div>
                                </td>
                                <td>
                                  {isProductActiveForInvoice(pdx) ? (
                                    <button
                                      type="button"
                                      className="btn btn-warning btn-sm"
                                      style={{ display: "block" }}
                                      title="Përjashto nga invoice"
                                      onClick={() => openDisableModal(allProduct[0]?.orderId, index)}
                                    >
                                      <span className="fa fa-ban"></span>
                                    </button>
                                  ) : (
                                    <span
                                      className="label label-default"
                                      style={{ display: "inline-block", backgroundColor: "#7f8c8d" }}
                                      title="Reason nuk mund të ndryshohet"
                                    >
                                      Disabled
                                    </span>
                                  )}
                                  {index === firstActiveProductIndex && canAddTransport && (
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      style={{ marginTop: "5px", display: "block" }}
                                      onClick={() => openTransportModal(allProduct[0]?.orderId, firstActiveProductIndex)}
                                    >
                                      Shto transport
                                    </button>
                                  )}
                                  {Number(pdx?.shipping_price) > 0 && (
                                    <div style={{ marginTop: "5px", fontSize: "12px", fontWeight: "bold" }}>
                                      Transport: {pdx.shipping_price}€
                                    </div>
                                  )}
                                  {isDisabled && (
                                    <div className="od-product-reason">
                                      <strong>Reason:</strong> {pdx?.reason || "—"}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            )
                          }
                          )}
                        </tbody>
                        <tbody>
                          <tr>
                            <td className="thumb">
                              <span><i className="fa fa-solid fa-truck"></i></span>
                              <p className="standard-p">Standard</p>
                              <tbody>
                                <tr>
                                </tr>
                              </tbody>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <tr className='input-order'>
                                <input type="text" value={ChangeDeliveryCharge} onChange={(e) => setChangeDeliveryCharge(e.target.value)} />
                                <span>
                                  {process.env.REACT_APP_CURRENCY}
                                </span>
                              </tr>
                            </td>
                            <td className='del-edit'>
                              <tr>
                                <button className=" fa fa-refresh btn btn-primary" onClick={(e) => editDeliveryMode(allProduct[0]?.orderId)}></button>
                                <button className="fa fa-trash btn btn-danger" onClick={(e) => deleteDeliveryMode(allProduct[0]?.orderId)}></button>{" "}
                              </tr>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      </div>

                      <div className="od-sec-1">
                        <div className="od-total">
                          <div>
                            <p>Items subtotal:</p>
                            <p>{sum.toFixed(2)} €</p>
                          </div>
                          <div>
                            <p>Shipping:</p>
                            <p>{shipping.toFixed(2)} €</p>
                          </div>
                          <div>
                            <p>Order Total:</p>
                            <p><strong>{orderTotal.toFixed(2)} {process.env.REACT_APP_CURRENCY}</strong></p>



                          </div>
                        </div>

                        <div className="posthead-bottom-part1 extra-note">
                          <div className="col-md-6 form-floating">
                            <label for="floatingTextarea">Customer note <span><i className="fa fa-solid fa-question"></i></span></label>
                            <textarea className="form-control" placeholder="Leave a comment here" id="floatingTextarea" onChange={(e) => setNotes(e.target.value)}></textarea>
                          </div>
                          <div className="col-md-6 form-floating">
                            <label for="floatingTextarea"> Staff note <span><i className="fa fa-solid fa-question"></i></span></label>
                            <textarea className="form-control" placeholder="Leave a comment here" id="floatingTextarea" onChange={(e) => setNotes(e.target.value)}></textarea>
                          </div>
                        </div>


                        <div className="od-refund">

                          <button type="button" className="btn btn-info" data-toggle="modal" data-target="#modal-info">
                            Refund
                          </button>
                          <span className="description">
                            <span className="woocommerce-help-tip"><i className="fa fa-solid fa-question"></i></span>
                            This order is no longer editable.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="box">
                    <div className="box-body od-sec-3">
                      <div className="postbox-headerr">
                        <div>
                          <h5 className="hndle ui-sortable-handle">Print Order</h5>
                        </div>
                        <div>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-chevron-up"></i></span>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-chevron-down"></i></span>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-sort-up"></i></span>
                        </div>
                      </div>
                      <div className="posthead-content">
                        <a href="/#" data-toggle="modal" data-target="#modal-default">Click here print order</a>
                      </div>

                    </div>
                  </div>
                  <div className="box">
                    <div className="box-body od-sec-3">
                      <div className="postbox-headerr">
                        <div>
                          <h5 className="hndle ui-sortable-handle">Print Fiscal</h5>
                        </div>
                        <div>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-chevron-up"></i></span>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-chevron-down"></i></span>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-sort-up"></i></span>
                        </div>
                      </div>
                      <div className="posthead-content">
                        <button onClick={(e) => textFile()}>Click here print fiscal</button>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="box-body od-sec-3">
                      <div className="postbox-headerr">
                        <div>
                          <h5 className="hndle ui-sortable-handle">Kthe Porosine</h5>
                        </div>
                        <div>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-chevron-up"></i></span>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-chevron-down"></i></span>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-sort-up"></i></span>
                        </div>
                      </div>
                      <div className="posthead-content">
                        <button onClick={(e) => handleReturnOrder()} style={{ backgroundColor: '#d9534f', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer' }}>
                          <i className="fa fa-undo" style={{ marginRight: '5px' }}></i>
                          Kthe Porosine
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="box-body od-sec-3">
                      <div className="postbox-headerr">
                        <div>
                          <h5 className="hndle ui-sortable-handle">Anulo Porosine</h5>
                        </div>
                        <div>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-chevron-up"></i></span>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-chevron-down"></i></span>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-sort-up"></i></span>
                        </div>
                      </div>
                      <div className="posthead-content">
                        <button onClick={(e) => handleCancelOrder()} style={{ backgroundColor: '#f0ad4e', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer' }}>
                          <i className="fa fa-times-circle" style={{ marginRight: '5px' }}></i>
                          Anulo Porosine
                        </button>
                      </div>
                    </div>
                  </div>
                  {canExchange && (
                    <div className="box">
                      <div className="box-body od-sec-3">
                        <div className="postbox-headerr">
                          <div>
                            <h5 className="hndle ui-sortable-handle">Nderro Porosine</h5>
                          </div>
                        </div>
                        <div className="posthead-content">
                          <button onClick={openExchangeModal} style={{ backgroundColor: '#5bc0de', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer' }}>
                            <i className="fa fa-exchange" style={{ marginRight: '5px' }}></i>
                            Nderro
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="box">
                    <div className="box-body od-sec-3">
                      <div className="postbox-headerr">
                        <div>
                          <h5 className="hndle ui-sortable-handle">Order actions</h5>
                        </div>
                        <div>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-chevron-up"></i></span>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-chevron-down"></i></span>
                          <span className="woocommerce-help-tip"><i className="fa fa-solid fa-sort-up"></i></span>
                        </div>
                      </div>
                      <div className="posthead-content choose-actions">
                        <select
                          className="form-control"
                          value={statusValue.length > 0 ? statusValue : allProduct[0]?.status}
                          onChange={(e) => { setStatusValue(e.target.value); setNotes(e.target.value); }}
                        >
                          {statusColor.map(stsClr => {
                            return (
                              <option value={stsClr.statusName} style={{ textTransform: "capitalize" }}>{stsClr.statusName}</option>
                            )
                          })}
                        </select>
                        <button><i className="fa fa-solid fa-chevron-right"></i></button>
                      </div>
                      <div className="posthead-bottom">
                        {/* <a href="/#">Move to trash</a> */}
                        <button className="btn-update" onClick={(e) => updateOrder()}>Update</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <Footer />
          <Tool />
          <div className="control-sidebar-bg" />
        </div>
      </div>

      <div
        className="modal modal-default fade in col-md-12"
        id="modal-info"
        style={{ display: `${modalBox ? "block" : "hidden"}` }}
      >
        <div className="modal-dialog" style={{ width: "80%" }}>
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <table className="od-table">
                <thead>
                  <tr className="od-tr">
                    <th className="item">Item <span><i className="fa fa-arrow-up"></i></span></th>
                    <th className="item-cost itemm" >Send</th>
                    <th className="item-cost itemm">Approved</th>
                    <th className="item-cost">Qty</th>
                    <th className="item-cost">without VAT</th>
                    <th className="item-cost itemm">Cost inc VAT</th>
                    <th className="item-cost">Total</th>
                  </tr>
                </thead>
                <tbody>

                  {allProduct[0]?.productList?.map((pdx, index) => {


                    return (
                      <tr key={pdx?._id}>
                        <td className="thumb">
                          <div className="">
                            <img width="100" height="140" src={pdx?.images[0]} className="" loading="lazy" alt="" />
                          </div>
                          <div className="name">
                            <a href={`https://albionline.com/productdetails/${pdx?._id}/${pdx?.catId}`}>{pdx?.name}
                            </a>
                            <div className="wc-order-item-sku"><strong>SKU:</strong> {pdx.item_code}</div>
                            <div className="wc-order-item-sku"><strong>Sizes:</strong> {pdx.size}</div>

                            <em className="wcpv-sold-by-order-details">Sold By:
                              <a href="https://management.albionline.com/vendor/women-secret/" title={pdx.vendor}>{pdx.vendor}</a>
                            </em>
                          </div>
                        </td>
                        <td>
                          <i className="fa fa-solid fa-check"></i>
                        </td>
                        <td>
                          <i className="fa fa-solid fa-check"></i>
                        </td>
                        <td>
                          <div className="view">
                            <div>{pdx?.quantity} ×</div>
                            <div>
                              <input
                                id={pdx?._id}
                                key={pdx?._id}
                                type="number"
                                min={1}
                                max={pdx?.quantity}
                                name={pdx?._id}
                                onChange={(e) => handleRefundChange(e, pdx?.item_code, pdx?.size, pdx?.sale_price > 0 ? pdx?.sale_price.toFixed(2) * parseFloat(pdx?.quantity).toFixed(2) : pdx?.regular_price.toFixed(2) * parseFloat(pdx?.quantity).toFixed(2), pdx?.sale_price, pdx?.regular_price)} />
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="view">{pdx?.sale_price > 0 ? (parseFloat(pdx?.sale_price).toFixed(2) - (parseFloat(pdx?.sale_price).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)).toFixed(2) : (parseFloat(pdx?.regular_price).toFixed(2) - (parseFloat(pdx?.regular_price).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)).toFixed(2)} €
                            { }
                          </div>
                          <div>
                            <input
                              id={pdx?._id}
                              key={pdx?._id}
                              name={pdx?._id}
                              type="number"
                              readOnly={true}
                              value={(pdx?.sale_price > 0 ? (parseFloat(pdx?.sale_price).toFixed(2) - (parseFloat(pdx?.sale_price).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)).toFixed(2) : (parseFloat(pdx?.regular_price).toFixed(2) - (parseFloat(pdx?.regular_price).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)).toFixed(2)) / qtyValue[pdx?._id]}
                            />
                          </div>

                        </td>
                        <td>
                          <div className="view">{pdx?.sale_price > 0 ? (parseFloat(pdx?.sale_price).toFixed(2) * parseFloat(pdx?.quantity).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2) : (parseFloat(pdx?.regular_price).toFixed(2) * parseFloat(pdx?.quantity).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)} €</div>
                          <div>
                            <input
                              id={pdx?._id}
                              key={pdx?._id}
                              name={pdx?._id}
                              type="number"
                              readOnly={true}
                              value={(pdx?.sale_price > 0 ? (parseFloat(pdx?.sale_price).toFixed(2) * parseFloat(pdx?.quantity).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2) : (parseFloat(pdx?.regular_price).toFixed(2) * parseFloat(pdx?.quantity).toFixed(2) * parseFloat(vatData).toFixed(2) / 100).toFixed(2)) / qtyValue[pdx?._id]} />
                          </div>

                        </td>
                        <td>
                          <div className="view">{signedProductTotal(pdx).toFixed(2)} €</div>

                        </td>
                      </tr>
                    )
                  }
                  )}
                </tbody>
                <tbody>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="od-sec-1">
            <div className="od-total">
              <div>
                <p>Items subtotal:</p>
                <p>{sum.toFixed(2)} €</p>
              </div>
              <div>
                <p>Shipping:</p>
                <p>{parseInt(allProduct[0]?.deliverMode)} €</p>
              </div>
              <div>
                <p>Order Total:</p>
                <p><strong>{(parseFloat(sum?.toFixed(2) || 0) + parseFloat(allProduct[0]?.deliverMode?.toFixed(2) || 0))?.toFixed(2)} {process.env.REACT_APP_CURRENCY}</strong></p>
              </div>
              <div>
                <p>Refund Amount:{" "}</p>
                <input type="text"
                  value={totalRefund}
                  readOnly={true} style={{ backgroundColor: "#f5f6f9", padding: "2px", marginLeft: "5px", borderRadius: "5px" }}
                />
              </div>

              <div className="od-refund">
                <textarea col="3" row="5" className='reasontext' placeholder="Reason for refund (optional)" onChange={(e) => setReasonForRefund(e.target.value)}></textarea>

                <button type="button" className="btn btn-info" onClick={(e) => refundNow()}>
                  Refund
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Invoice refreshToken={invoiceRefreshToken} />
      {disableModal.show && (
        <div className="modal fade in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" onClick={closeDisableModal}>
                  <span aria-hidden="true">×</span>
                </button>
                <h4 className="modal-title">Përjashto produktin nga invoice</h4>
              </div>
              <div className="modal-body">
                <label htmlFor="disable-reason">Arsyeja (nuk mund të ndryshohet më pas)</label>
                <textarea
                  id="disable-reason"
                  className="form-control"
                  rows="4"
                  placeholder="Shkruani arsyen pse ky produkt nuk duhet të përfshihet në invoice"
                  value={disableModal.reason}
                  onChange={(e) => setDisableModal({ ...disableModal, reason: e.target.value })}
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" onClick={closeDisableModal}>Anulo</button>
                <button type="button" className="btn btn-danger" onClick={submitDisableProduct}>Disable</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {transportModal.show && (
        <div className="modal fade in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" onClick={closeTransportModal}>
                  <span aria-hidden="true">×</span>
                </button>
                <h4 className="modal-title">Shto transport</h4>
              </div>
              <div className="modal-body" style={{ textAlign: "center" }}>
                <p style={{ marginBottom: "15px" }}>Zgjidhni çmimin e transportit:</p>
                <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => addProductTransport(3)}
                  >
                    Transport 3€
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => addProductTransport(6)}
                  >
                    Transport 6€
                  </button>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" onClick={closeTransportModal}>Anulo</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {exchangeModal.show && (
        <div className="modal fade in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" onClick={closeExchangeModal}>
                  <span aria-hidden="true">×</span>
                </button>
                <h4 className="modal-title">Nderro porosine {currentOrderId}</h4>
              </div>
              <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                <h5>Produktet që dalin (−)</h5>
                <p style={{ color: "#777" }}>Zgjidhni cilat produkte të kësaj porosie do të ndërrohen. Ato hyjnë në EAO me sasi negative.</p>
                {exchangeCandidates.length === 0 ? (
                  <p>Nuk ka produkte aktive për exchange.</p>
                ) : (
                  exchangeCandidates.map(({ product, index }) => (
                    <label key={`${product?.item_code}-${index}`} style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "8px" }}>
                      <input
                        type="checkbox"
                        checked={exchangeModal.selectedIndexes.includes(index)}
                        onChange={() => toggleExchangeIndex(index)}
                      />
                      <span>
                        <strong>{product?.name}</strong>
                        {" "}— SKU: {product?.item_code}
                        {product?.size ? `, ${product.size}` : ""}
                        {" "}× {product?.quantity}
                        {product?.location ? ` · ${product.location}` : ""}
                      </span>
                    </label>
                  ))
                )}

                <hr />
                <h5>Produkti që hyn (+)</h5>
                <p style={{ color: "#777" }}>
                  {exchangeLocation
                    ? `Kërkimi bëhet vetëm në location ${exchangeLocation}. Nëse kërkoni me external, zgjidhni SKU-në e atij produkti. Transporti 3€ shtohet te produkti i parë që hyn.`
                    : "Zgjidhni së pari produktin që ndërrohet. Kërkimi lejohet vetëm në location-in e atij produkti."}
                </p>
                <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="SKU ose External ID"
                    value={exchangeModal.search}
                    onChange={(e) => setExchangeModal((prev) => ({ ...prev, search: e.target.value }))}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") searchExchangeProducts();
                    }}
                  />
                  <button type="button" className="btn btn-primary" onClick={searchExchangeProducts} disabled={exchangeModal.searching || !exchangeLocation}>
                    {exchangeModal.searching ? "Duke kërkuar..." : "Kërko"}
                  </button>
                </div>

                {exchangeModal.results.map((product) => {
                  const alreadyAdded = exchangeModal.incoming.some(
                    (item) => item.skuId === product.skuId && item.externalId === product.externalId
                  );
                  const unit = Number(product.sale_price) > 0 ? Number(product.sale_price) : Number(product.regular_price);
                  return (
                    <div key={`${product.externalId}-${product.skuId}`} style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px", borderBottom: "1px solid #eee", paddingBottom: "8px" }}>
                      {product.image ? (
                        <img src={product.image} alt="" width="48" height="64" style={{ objectFit: "contain" }} />
                      ) : null}
                      <div style={{ flex: 1 }}>
                        <div><strong>{product.name}</strong></div>
                        <div>SKU: {product.skuId}</div>
                        <div>External: {product.externalId || "—"} · {product.location || "—"}</div>
                        <div>
                          {product.size ? `Madhësia: ${product.size}` : ""}
                          {product.colour ? ` · ${product.colour}` : ""}
                          {` · ${unit.toFixed(2)}€`}
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        disabled={alreadyAdded}
                        onClick={() => addIncomingProduct(product)}
                      >
                        {alreadyAdded ? "Shtuar" : "Shto"}
                      </button>
                    </div>
                  );
                })}

                {exchangeModal.incoming.length > 0 && (
                  <div style={{ marginTop: "12px" }}>
                    <strong>Të zgjedhura për +</strong>
                    {exchangeModal.incoming.map((product, incomingIndex) => (
                      <div key={`${product.externalId}-${product.skuId}`} style={{ display: "flex", gap: "10px", alignItems: "center", marginTop: "8px" }}>
                        <div style={{ flex: 1 }}>
                          {product.name} — SKU: {product.skuId}
                          {incomingIndex === 0 ? " · Transport 3€" : ""}
                        </div>
                        <input
                          type="number"
                          min="1"
                          max="99"
                          value={product.quantity}
                          onChange={(e) => updateIncomingQty(product.skuId, product.externalId, e.target.value)}
                          style={{ width: "70px" }}
                        />
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => removeIncomingProduct(product.skuId, product.externalId)}>
                          Hiq
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                {exchangeModal.error && (
                  <div className="alert alert-danger" style={{ marginTop: "12px", marginBottom: 0 }}>
                    {exchangeModal.error}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" onClick={closeExchangeModal} disabled={exchangeModal.submitting}>
                  Anulo
                </button>
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={submitExchangeOrder}
                  disabled={exchangeModal.submitting || !exchangeModal.selectedIndexes.length || !exchangeModal.incoming.length}
                >
                  {exchangeModal.submitting ? "Duke krijuar..." : "Krijo EAO"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

